import angular from 'angular';
import incomeCalculator from './incomeCalculator';
import './style.scss';

export default angular
  .module('scenes.incomeCalculator', [])
  .component('incomeCalculator', incomeCalculator).name;
